export default class {
    propertyId = null
    confirmationModalElement = null
    confirmationModal = null
    addFormElement = null
    removeFormElement = null
    addWishlistLoadingIconElement = null
    removeWishlistLoadingIconElement = null

    options = {
        element: null
    }
    
    constructor(options) {
        this.options = Object.assign(this.options, options);
        this._setupPropertyId();
        this._setupConfirmationModalElement();
        this._setupLoadingIcons();
        this._bindFavourite("add");
        this._bindFavourite("remove");
        this._bindDontShowMessage();
    }

    _setupPropertyId() {
        this.propertyId = this.options.element.dataset.propertyid;
    }

    _setupLoadingIcons() {
        this.addFormElement = this.options.element.querySelector('.add-wishlist');
        this.removeFormElement = this.options.element.querySelector('.remove-wishlist');

        this.addWishlistLoadingIconElement = this.addFormElement.querySelector('.loader');
        this.removeWishlistLoadingIconElement = this.removeFormElement.querySelector('.loader');
    }

    _setupConfirmationModalElement() {
        this.confirmationModalElement = document.getElementById('confirmation-box-' + this.propertyId);
    }

    _bindDontShowMessage() {
        // on this.options.element.querySelector('.dont-show-message') checkbox being checking, add a cookie wishlist-dont-show-message and set to true.  Vice Versa
        let self = this;
        this.confirmationModalElement.querySelector('.wishlist-checkbox').addEventListener('change', function(event) {
            if (event.currentTarget.checked) {
                self._setCookie("wishlist-dont-show-message", true);
            } else {
                self._removeCookie("wishlist-dont-show-message");
            }
        });

        
    }
    _getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    _setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    _removeCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
    issetDontShowMessage() {
        return this._getCookie("wishlist-dont-show-message") == "true";
    }
    _bindFavourite(action) {
        let self = this;
        let targetElementClass  = ".add-wishlist";
        let apiPath = "/add-wishlist";

        if (action == "remove") {
            targetElementClass = ".remove-wishlist";
            apiPath = "/remove-wishlist";
        }

        let targetElement = this.options.element.querySelector(targetElementClass);


        targetElement.addEventListener('submit', function(event) {
            event.stopPropagation();
            event.preventDefault();

            if (action == "add"
                || action == "remove" && self.issetDontShowMessage()
            ) {
                self._updateDatabaseRecord(self.propertyId, apiPath);
                return false;
            }

            if (!self.confirmationModal) {
                self.confirmationModal = new bootstrap.Modal(document.getElementById('confirmation-box-' + self.propertyId));
                document.getElementById("confirmation-box-" + self.propertyId + "-label-confirm-button")
                    .addEventListener('click', function(event) {
                        self._updateDatabaseRecord(self.propertyId, apiPath);
                        self.confirmationModal.hide();
                    });
                // move the document.getElementById('confirmation-box-' + propertyId) to body
                document.body.appendChild(document.getElementById('confirmation-box-' + self.propertyId));
            }
            
            self.confirmationModal.show();
        });
    }

    // get current active form
    // show loading icon of active form, hide favourite icon
    // do ajax operation
    // if success, hide loading icon of active form, switch active form, show favourite icon of active form
    _updateFavouriteIcon(id) {
        let self = this;
        const xhttp = new XMLHttpRequest();
        this._triggerLoadingIcon('on');
        xhttp.onload = function() {
            let data = JSON.parse(this.responseText);
            self._triggerLoadingIcon('off');
            if (data.result === true) {
                self._lightupFavoriteIcon();
            } else {
                self._dimdownFavoriteIcon();
            }
        }
        xhttp.open("GET", "/is-in-my-wishlist?id=" + id, true);
        xhttp.send();
        
    }
    _updateDatabaseRecord(id, action) {
        const formData = (function() {
            const data = new FormData();
            data.append("_token", document.getElementsByName("_token")[0].value);
            data.append("id", id);
            return data;
        })();

        const xhttp = new XMLHttpRequest();
        xhttp.onload = () => this._updateFavouriteIcon(id);
        xhttp.open("POST", action, true);
        xhttp.send(
            formData
        );   // need csrf here
    }
    _triggerLoadingIcon(status) {
        let currentActiveForm = this.addFormElement.classList.contains('d-none') ? 'remove' : 'add';
        if (status == 'on') {
            this._showLoadingIcon(currentActiveForm);
            this._hideFavouriteIcon(currentActiveForm);
        } else {
            this._hideLoadingIcon(currentActiveForm);
            this._showFavouriteIcon(currentActiveForm);
        }
    }
    _hideLoadingIcon(target) {
        let targetElement = target == 'add' ? this.addWishlistLoadingIconElement : this.removeWishlistLoadingIconElement;
        targetElement.classList.add('d-none');
    }
    _showLoadingIcon(target) {
        let targetElement = target == 'add' ? this.addWishlistLoadingIconElement : this.removeWishlistLoadingIconElement;
        targetElement.classList.remove('d-none');
    }
    _hideFavouriteIcon(target) {
        let targetElement = target == 'add' ? this.addFormElement : this.removeFormElement;
        targetElement.querySelector('.favourite-icon').classList.add('d-none');
    }
    _showFavouriteIcon(target) {
        let targetElement = target == 'add' ? this.addFormElement : this.removeFormElement;
        targetElement.querySelector('.favourite-icon').classList.remove('d-none');
    }
    _lightupFavoriteIcon() {
        // show removewishlist form
        this.addFormElement.classList.add('d-none');
        this.removeFormElement.classList.remove('d-none');
    }
    _dimdownFavoriteIcon() {
        this.addFormElement.classList.remove('d-none');
        this.removeFormElement.classList.add('d-none');
    }
    
}